/* eslint-disable sonarjs/no-duplicate-string */
import { getIconBaseUrl } from "../../utils/assets";
export const CARAVAN_OWNERSHIP_TAB = "Caravan Ownership";
export const mainNavigationDefaultData = [
    {
        name: "Our parks",
        url: "/parks",
        tabmenuLabel: "I’m looking for…",
        tabmenu: [
            {
                name: "Holidays",
                submenu: [
                    {
                        name: "Blackpool",
                        url: "/parks/blackpool",
                        submenu: [
                            {
                                name: "Cala Gran",
                                url: "/parks/blackpool/cala-gran",
                            },
                            {
                                name: "Marton Mere",
                                url: "/parks/blackpool/marton-mere",
                            },
                        ],
                    },
                    {
                        name: "Cornwall",
                        url: "/parks/cornwall",
                        submenu: [
                            {
                                name: "Perran Sands",
                                url: "/parks/cornwall/perran-sands",
                            },
                            {
                                name: "Riviere Sands",
                                url: "/parks/cornwall/riviere-sands",
                            },
                        ],
                    },
                    {
                        name: "Devon",
                        url: "/parks/devon",
                        submenu: [
                            {
                                name: "Devon Cliffs",
                                url: "/parks/devon/devon-cliffs",
                            },
                        ],
                    },
                    {
                        name: "Dorset",
                        url: "/parks/dorset",
                        submenu: [
                            {
                                name: "Littlesea",
                                url: "/parks/dorset/littlesea",
                            },
                            {
                                name: "Rockley Park",
                                url: "/parks/dorset/rockley-park",
                            },
                            {
                                name: "Seaview",
                                url: "/parks/dorset/seaview",
                            },
                            {
                                name: "Weymouth Bay",
                                url: "/parks/dorset/weymouth-bay",
                            },
                        ],
                    },
                    {
                        name: "Essex",
                        url: "/parks/essex",
                        submenu: [
                            {
                                name: "Orchards",
                                url: "/parks/essex/the-orchards",
                            },
                        ],
                    },
                    {
                        name: "Kent",
                        url: "/parks/kent",
                        submenu: [
                            {
                                name: "Kent Coast",
                                url: "/parks/kent/kent-coast",
                            },
                        ],
                    },
                    {
                        name: "Lake District",
                        url: "/parks/lake-district",
                        submenu: [
                            {
                                name: "Lakeland",
                                url: "/parks/lake-district/lakeland",
                            },
                        ],
                    },
                    {
                        name: "Lincolnshire",
                        url: "/parks/lincolnshire",
                        submenu: [
                            {
                                name: "Cleethorpes Beach",
                                url: "/parks/lincolnshire/cleethorpes-beach",
                            },
                            {
                                name: "Golden Sands",
                                url: "/parks/lincolnshire/golden-sands",
                            },
                            {
                                name: "Skegness",
                                url: "/parks/lincolnshire/skegness-holiday-park",
                            },
                        ],
                    },
                    {
                        name: "Norfolk",
                        url: "/parks/norfolk",
                        submenu: [
                            {
                                name: "Caister-on-Sea",
                                url: "/parks/norfolk/caister-on-sea",
                            },
                            {
                                name: "Hopton",
                                url: "/parks/norfolk/hopton",
                            },
                            {
                                name: "Seashore",
                                url: "/parks/norfolk/seashore",
                            },
                            {
                                name: "Wild Duck",
                                url: "/parks/norfolk/wild-duck",
                            },
                        ],
                    },
                    {
                        name: "Northumberland",
                        url: "/parks/northumberland",
                        submenu: [
                            {
                                name: "Berwick",
                                url: "/parks/northumberland/berwick",
                            },
                            {
                                name: "Haggerston Castle",
                                url: "/parks/northumberland/haggerston-castle",
                            },
                        ],
                    },
                    {
                        name: "North Wales",
                        url: "/parks/north-wales",
                        submenu: [
                            {
                                name: "Cardigan View",
                            },
                            {
                                name: "Garreg Wen",
                            },
                            {
                                name: "Greenacres",
                                url: "/parks/north-wales/greenacres",
                            },
                            {
                                name: "Hafan y Mor",
                                url: "/parks/north-wales/hafan-y-mor",
                            },
                            {
                                name: "Presthaven",
                                url: "/parks/north-wales/presthaven",
                            },
                        ],
                    },
                    {
                        name: "Scotland",
                        url: "/parks/scotland",
                        submenu: [
                            {
                                name: "Craig Tara",
                                url: "/parks/scotland/craig-tara",
                            },
                            {
                                name: "Seton Sands",
                                url: "/parks/scotland/seton-sands",
                            },
                        ],
                    },
                    {
                        name: "Somerset",
                        url: "/parks/somerset",
                        submenu: [
                            {
                                name: "Burnham-on-Sea",
                                url: "/parks/somerset/burnham-on-sea",
                            },
                            {
                                name: "Doniford Bay",
                                url: "/parks/somerset/doniford-bay",
                            },
                        ],
                    },
                    {
                        name: "South Wales",
                        url: "/parks/south-wales",
                        submenu: [
                            {
                                name: "Kiln Park",
                                url: "/parks/south-wales/kiln-park",
                            },
                            {
                                name: "Lydstep Beach",
                                url: "/parks/south-wales/lydstep-beach",
                            },
                            {
                                name: "Penally Court",
                                url: "/parks/south-wales/penally-court",
                            },
                            {
                                name: "Quay West",
                                url: "/parks/south-wales/quay-west",
                            },
                        ],
                    },
                    {
                        name: "Sussex",
                        url: "/parks/sussex",
                        submenu: [
                            {
                                name: "Church Farm",
                                url: "/parks/sussex/church-farm",
                            },
                            {
                                name: "Combe Haven",
                                url: "/parks/sussex/combe-haven",
                            },
                        ],
                    },
                    {
                        name: "Yorkshire",
                        url: "/parks/yorkshire",
                        submenu: [
                            {
                                name: "Blue Dolphin",
                                url: "/parks/yorkshire/blue-dolphin",
                            },
                            {
                                name: "Far Grange",
                            },
                            {
                                name: "Primrose Valley",
                                url: "/parks/yorkshire/primrose-valley",
                            },
                            {
                                name: "Reighton Sands",
                                url: "/parks/yorkshire/reighton-sands",
                            },
                            {
                                name: "Thornwick Bay",
                                url: "/parks/yorkshire/thornwick-bay",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Touring & Camping",
                submenu: [
                    {
                        name: "Blackpool",
                        url: "/touring-camping/parks/blackpool",
                        submenu: [
                            {
                                name: "Cala Gran",
                            },
                            {
                                name: "Marton Mere",
                                url: "/touring-camping/parks/blackpool/marton-mere",
                            },
                        ],
                    },
                    {
                        name: "Cornwall",
                        url: "/touring-camping/parks/cornwall",
                        submenu: [
                            {
                                name: "Perran Sands",
                                url: "/touring-camping/parks/cornwall/perran-sands",
                            },
                            {
                                name: "Riviere Sands",
                            },
                        ],
                    },
                    {
                        name: "Devon",
                        submenu: [
                            {
                                name: "Devon Cliffs",
                            },
                        ],
                    },
                    {
                        name: "Dorset",
                        url: "/touring-camping/parks/dorset",
                        submenu: [
                            {
                                name: "Littlesea",
                                url: "/touring-camping/parks/dorset/littlesea",
                            },
                            {
                                name: "Rockley Park",
                            },
                            {
                                name: "Seaview",
                                url: "/touring-camping/parks/dorset/seaview",
                            },
                            {
                                name: "Weymouth Bay",
                            },
                        ],
                    },
                    {
                        name: "Essex",
                        submenu: [
                            {
                                name: "Orchards",
                            },
                        ],
                    },
                    {
                        name: "Kent",
                        submenu: [
                            {
                                name: "Kent Coast",
                            },
                        ],
                    },
                    {
                        name: "Lake District	",
                        url: "/touring-camping/parks/lake-district",
                        submenu: [
                            {
                                name: "Lakeland",
                                url: "/touring-camping/parks/lake-district/lakeland",
                            },
                        ],
                    },
                    {
                        name: "Lincolnshire",
                        url: "/touring-camping/parks/lincolnshire",
                        submenu: [
                            {
                                name: "Cleethorpes Beach",
                                url: "/touring-camping/parks/lincolnshire/cleethorpes-beach",
                            },
                            {
                                name: "Golden Sands",
                                url: "/touring-camping/parks/lincolnshire/golden-sands",
                            },
                            {
                                name: "Skegness",
                                url: "/touring-camping/parks/lincolnshire/skegness-holiday-park",
                            },
                        ],
                    },
                    {
                        name: "Norfolk",
                        submenu: [
                            {
                                name: "Caister-on-Sea",
                            },
                            {
                                name: "Hopton",
                            },
                            {
                                name: "Seashore",
                            },
                            {
                                name: "Wild Duck",
                            },
                        ],
                    },
                    {
                        name: "Northumberland",
                        url: "/touring-camping/parks/northumberland",
                        submenu: [
                            {
                                name: "Berwick",
                            },
                            {
                                name: "Haggerston Castle",
                                url: "/touring-camping/parks/northumberland/haggerston-castle",
                            },
                        ],
                    },
                    {
                        name: "North Wales",
                        url: "/touring-camping/parks/north-wales",
                        submenu: [
                            {
                                name: "Cardigan View",
                            },
                            {
                                name: "Garreg Wen",
                            },
                            {
                                name: "Greenacres",
                                url: "/touring-camping/parks/north-wales/greenacres",
                            },
                            {
                                name: "Hafan y Mor",
                                url: "/touring-camping/parks/north-wales/hafan-y-mor",
                            },
                            {
                                name: "Presthaven",
                                url: "/touring-camping/parks/north-wales/presthaven",
                            },
                        ],
                    },
                    {
                        name: "Scotland",
                        url: "/touring-camping/parks/scotland",
                        submenu: [
                            {
                                name: "Craig Tara",
                            },
                            {
                                name: "Seton Sands",
                                url: "/touring-camping/parks/scotland/seton-sands",
                            },
                        ],
                    },
                    {
                        name: "Somerset",
                        submenu: [
                            {
                                name: "Burnham-on-Sea",
                            },
                            {
                                name: "Doniford Bay",
                            },
                        ],
                    },
                    {
                        name: "South Wales",
                        url: "/touring-camping/parks/south-wales",
                        submenu: [
                            {
                                name: "Kiln Park",
                                url: "/touring-camping/parks/south-wales/kiln-park",
                            },
                            {
                                name: "Lydstep Beach",
                            },
                            {
                                name: "Penally Court",
                            },
                            {
                                name: "Quay West",
                            },
                        ],
                    },
                    {
                        name: "Sussex",
                        submenu: [
                            {
                                name: "Church Farm",
                            },
                            {
                                name: "Combe Haven",
                            },
                        ],
                    },
                    {
                        name: "Yorkshire",
                        url: "/touring-camping/parks/yorkshire",
                        submenu: [
                            {
                                name: "Blue Dolphin",
                                url: "/touring-camping/parks/yorkshire/blue-dolphin",
                            },
                            {
                                name: "Far Grange",
                            },
                            {
                                name: "Primrose Valley",
                                url: "/touring-camping/parks/yorkshire/primrose-valley",
                            },
                            {
                                name: "Reighton Sands",
                                url: "/touring-camping/parks/yorkshire/reighton-sands",
                            },
                            {
                                name: "Thornwick Bay",
                                url: "/touring-camping/parks/yorkshire/thornwick-bay",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Caravan Ownership",
                submenu: [
                    {
                        name: "Blackpool",
                        url: "/caravans-for-sale/parks/blackpool",
                        submenu: [
                            {
                                name: "Cala Gran",
                                url: "/caravans-for-sale/parks/blackpool/cala-gran",
                            },
                            {
                                name: "Marton Mere",
                                url: "/caravans-for-sale/parks/blackpool/marton-mere",
                            },
                        ],
                    },
                    {
                        name: "Cornwall",
                        url: "/caravans-for-sale/parks/cornwall",
                        submenu: [
                            {
                                name: "Perran Sands",
                                url: "/caravans-for-sale/parks/cornwall/perran-sands",
                            },
                            {
                                name: "Riviere Sands",
                            },
                        ],
                    },
                    {
                        name: "Devon",
                        url: "/caravans-for-sale/parks/devon",
                        submenu: [
                            {
                                name: "Devon Cliffs",
                                url: "/caravans-for-sale/parks/devon/devon-cliffs",
                            },
                        ],
                    },
                    {
                        name: "Dorset",
                        url: "/caravans-for-sale/parks/dorset",
                        submenu: [
                            {
                                name: "Littlesea",
                                url: "/caravans-for-sale/parks/dorset/littlesea",
                            },
                            {
                                name: "Rockley Park",
                                url: "/caravans-for-sale/parks/dorset/rockley-park",
                            },
                            {
                                name: "Seaview",
                            },
                            {
                                name: "Weymouth Bay",
                                url: "/caravans-for-sale/parks/dorset/weymouth-bay",
                            },
                        ],
                    },
                    {
                        name: "Essex",
                        url: "/caravans-for-sale/parks/essex",
                        submenu: [
                            {
                                name: "Orchards",
                                url: "/caravans-for-sale/parks/essex/the-orchards",
                            },
                        ],
                    },
                    {
                        name: "Kent",
                        url: "/caravans-for-sale/parks/kent",
                        submenu: [
                            {
                                name: "Kent Coast",
                                url: "/caravans-for-sale/parks/kent/kent-coast",
                            },
                        ],
                    },
                    {
                        name: "Lake District",
                        url: "/caravans-for-sale/parks/lake-district",
                        submenu: [
                            {
                                name: "Lakeland",
                                url: "/caravans-for-sale/parks/lake-district/lakeland",
                            },
                        ],
                    },
                    {
                        name: "Lincolnshire",
                        url: "/caravans-for-sale/parks/lincolnshire",
                        submenu: [
                            {
                                name: "Cleethorpes Beach",
                                url: "/caravans-for-sale/parks/lincolnshire/cleethorpes-beach",
                            },
                            {
                                name: "Golden Sands",
                                url: "/caravans-for-sale/parks/lincolnshire/golden-sands",
                            },
                            {
                                name: "Skegness",
                                url: "/caravans-for-sale/parks/lincolnshire/skegness",
                            },
                        ],
                    },
                    {
                        name: "Norfolk",
                        url: "/caravans-for-sale/parks/norfolk",
                        submenu: [
                            {
                                name: "Caister-on-Sea",
                                url: "/caravans-for-sale/parks/norfolk/caister-on-sea",
                            },
                            {
                                name: "Hopton",
                                url: "/caravans-for-sale/parks/norfolk/hopton",
                            },
                            {
                                name: "Seashore",
                                url: "/caravans-for-sale/parks/norfolk/seashore",
                            },
                            {
                                name: "Wild Duck",
                                url: "/caravans-for-sale/parks/norfolk/wild-duck",
                            },
                        ],
                    },
                    {
                        name: "Northumberland",
                        url: "/caravans-for-sale/parks/northumberland",
                        submenu: [
                            {
                                name: "Berwick",
                                url: "/caravans-for-sale/parks/northumberland/berwick",
                            },
                            {
                                name: "Haggerston Castle",
                                url: "/caravans-for-sale/parks/northumberland/haggerston-castle",
                            },
                        ],
                    },
                    {
                        name: "North Wales",
                        url: "/caravans-for-sale/parks/north-wales",
                        submenu: [
                            {
                                name: "Cardigan View",
                                url: "/caravans-for-sale/parks/north-wales/cardigan-view",
                            },
                            {
                                name: "Garreg Wen",
                                url: "/caravans-for-sale/parks/north-wales/garreg-wen",
                            },
                            {
                                name: "Greenacres",
                                url: "/caravans-for-sale/parks/north-wales/greenacres",
                            },
                            {
                                name: "Hafan y Mor",
                                url: "/caravans-for-sale/parks/north-wales/hafan-y-mor",
                            },
                            {
                                name: "Presthaven",
                                url: "/caravans-for-sale/parks/north-wales/presthaven",
                            },
                        ],
                    },
                    {
                        name: "Scotland",
                        url: "/caravans-for-sale/parks/scotland",
                        submenu: [
                            {
                                name: "Craig Tara",
                                url: "/caravans-for-sale/parks/scotland/craig-tara",
                            },
                            {
                                name: "Seton Sands",
                                url: "/caravans-for-sale/parks/scotland/seton-sands",
                            },
                        ],
                    },
                    {
                        name: "Somerset",
                        url: "/caravans-for-sale/parks/somerset",
                        submenu: [
                            {
                                name: "Burnham-on-Sea",
                                url: "/caravans-for-sale/parks/somerset/burnham-on-sea",
                            },
                            {
                                name: "Doniford Bay",
                                url: "/caravans-for-sale/parks/somerset/doniford-bay",
                            },
                        ],
                    },
                    {
                        name: "South Wales",
                        url: "/caravans-for-sale/parks/south-wales",
                        submenu: [
                            {
                                name: "Kiln Park",
                                url: "/caravans-for-sale/parks/south-wales/kiln-park",
                            },
                            {
                                name: "Lydstep Beach",
                                url: "/caravans-for-sale/parks/south-wales/lydstep-beach",
                            },
                            {
                                name: "Penally Court",
                                url: "/caravans-for-sale/parks/south-wales/penally-court",
                            },
                            {
                                name: "Quay West",
                                url: "/caravans-for-sale/parks/south-wales/quay-west",
                            },
                        ],
                    },
                    {
                        name: "Sussex",
                        url: "/caravans-for-sale/parks/sussex",
                        submenu: [
                            {
                                name: "Church Farm",
                                url: "/caravans-for-sale/parks/sussex/church-farm",
                            },
                            {
                                name: "Combe Haven",
                                url: "/caravans-for-sale/parks/sussex/combe-haven",
                            },
                        ],
                    },
                    {
                        name: "Yorkshire",
                        url: "/caravans-for-sale/parks/yorkshire",
                        submenu: [
                            {
                                name: "Blue Dolphin",
                                url: "/caravans-for-sale/parks/yorkshire/blue-dolphin",
                            },
                            {
                                name: "Far Grange",
                                url: "/caravans-for-sale/parks/yorkshire/far-grange",
                            },
                            {
                                name: "Primrose Valley",
                                url: "/caravans-for-sale/parks/yorkshire/primrose-valley",
                            },
                            {
                                name: "Reighton Sands",
                                url: "/caravans-for-sale/parks/yorkshire/reighton-sands",
                            },
                            {
                                name: "Thornwick Bay",
                                url: "/caravans-for-sale/parks/yorkshire/thornwick-bay",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        name: "Holidays",
        url: "/holidays",
        curtainMenu: [
            {
                name: "Discover Haven",
                submenu: [
                    {
                        name: "Our parks",
                        url: "/parks",
                    },
                    { name: "Park Picker", url: "/parks/which-park-is-right-for-me" },
                    {
                        name: "What's New",
                        url: "/discover/whats-new",
                    },
                    {
                        name: "Food & Drink",
                        url: "/discover/food-and-drink",
                    },
                    {
                        name: "Entertainment",
                        url: "/discover/entertainment",
                    },
                    {
                        name: "Our Pools",
                        url: "/discover/our-pools",
                    },
                    {
                        name: "Activities",
                        url: "/discover/activities",
                    },
                    {
                        name: "Holiday packages",
                        url: "/discover/holiday-packages",
                    },
                    {
                        name: "Shopping",
                        url: "/discover/shopping",
                    },
                ],
            },
            {
                name: "Accommodation",
                submenu: [
                    {
                        name: "Accommodation overview",
                        url: "/discover/accommodation",
                    },
                    {
                        name: "Caravans",
                        url: "/discover/accommodation/caravans",
                    },
                    {
                        name: "Lodges",
                        url: "/discover/accommodation/lodges",
                    },
                    {
                        name: "Apartments",
                        url: "/discover/accommodation/apartments",
                    },
                    {
                        name: "Chalets",
                        url: "/discover/accommodation/chalets",
                    },
                    {
                        name: "Glamping",
                        url: "/discover/accommodation/glamping",
                    },
                    {
                        name: "Accessible",
                        url: "/holidays/accessible",
                    },
                    {
                        name: "Choose your holiday home",
                        url: "/holidays/extras/choose-your-holiday-home",
                    },
                ],
            },
            {
                name: "Holiday Types",
                submenu: [
                    {
                        name: "Holidays overview",
                        url: "/holidays",
                    },
                    {
                        name: "Holidays for 2025",
                        url: "/holidays/2025",
                    },
                    {
                        name: "Summer 2025 holidays",
                        url: "/holidays/summer",
                    },
                    {
                        name: "School Holidays 2025",
                        url: "/holidays/school",
                    },
                    {
                        name: "Easter 2025 holidays",
                        url: "/holidays/easter",
                    },
                    {
                        name: "Holidays for 2026",
                        url: "/holidays/2026",
                    },
                    {
                        name: "Half term holidays",
                        url: "/holidays/half-term",
                    },
                    {
                        name: "UK beach holidays",
                        url: "/holidays/uk-beach-holidays",
                    },
                    {
                        name: "Caravan holidays",
                        url: "/holidays/caravan-holidays",
                    },
                    {
                        name: "Lodge holidays",
                        url: "/holidays/lodges",
                    },
                    {
                        name: "Glamping holidays",
                        url: "/holidays/glamping",
                    },
                ],
            },
            {
                name: "Break types",
                submenu: [
                    {
                        name: "UK breaks",
                        url: "/holidays/uk-breaks",
                    },
                    {
                        name: "Weekend breaks",
                        url: "/holidays/uk-breaks/weekend",
                    },
                    {
                        name: "Midweek breaks",
                        url: "/holidays/uk-breaks/midweek",
                    },
                    {
                        name: "May half term breaks",
                        url: "/holidays/half-term/may",
                    },
                    {
                        name: "Autumn breaks",
                        url: "/holidays/autumn",
                    },
                    {
                        name: "Special breaks",
                        url: "/holidays/special-breaks",
                    },
                    {
                        name: "Christmas and New Year breaks",
                        url: "/holidays/christmas-and-new-year",
                    },
                    {
                        name: "Self catering",
                        url: "/holidays/self-catering",
                    },
                ],
            },
            {
                name: "Best for",
                submenu: [
                    {
                        name: "Family holidays",
                        url: "/holidays/family",
                    },
                    {
                        name: "Tots breaks",
                        url: "/holidays/family/baby-toddler",
                    },
                    {
                        name: "Couple breaks",
                        url: "/holidays/uk-breaks/couples",
                    },
                    {
                        name: "Dog friendly breaks",
                        url: "/holidays/dog-friendly",
                    },
                    {
                        name: "Fishing holidays",
                        url: "/holidays/fishing",
                    },
                    {
                        name: "Golf breaks",
                        url: "/holidays/golf",
                    },
                ],
            },
            {
                name: "Inspiration",
                submenu: [
                    {
                        name: "Holiday inspiration",
                        url: "/holiday-inspiration",
                    },
                    {
                        name: "Things to do in the UK",
                        url: "/things-to-do",
                    },
                    {
                        name: "Beaches in the UK",
                        url: "/beaches",
                    },
                ],
            },
        ],
    },
    {
        name: "Touring and Camping",
        url: "/touring-camping",
        submenu: [
            {
                name: "Our parks",
                url: "/touring-camping/parks",
            },
            {
                name: "Pitches and facilities",
                url: "/touring-camping/pitches-facilities",
            },
            {
                name: "2025 breaks",
                url: "/touring-camping",
            },
        ],
    },
    {
        name: CARAVAN_OWNERSHIP_TAB,
        url: "/caravans-for-sale",
        curtainMenu: [
            {
                submenu: [
                    {
                        name: "Caravan Ownership",
                        url: "/caravans-for-sale",
                    },
                    {
                        name: "Static caravans for sale",
                        url: "/caravans-for-sale/static-caravans-for-sale",
                    },
                    {
                        name: "Our parks",
                        url: "/caravans-for-sale/parks",
                    },
                    {
                        name: "Our offers",
                        url: "/caravans-for-sale/offers",
                    },
                ],
            },
            {
                name: "Caravans & lodges for sale",
                submenu: [
                    {
                        name: "New caravans for sale",
                        url: "/caravans-for-sale/new",
                    },
                    {
                        name: "Used caravans for sale",
                        url: "/caravans-for-sale/used",
                    },
                    {
                        name: "Lodges for sale",
                        url: "/caravans-for-sale/lodges-for-sale",
                    },
                    {
                        name: "Search all",
                        url: "/caravans-for-sale/caravan-search",
                    },
                ],
            },
            {
                name: "Owner benefits",
                submenu: [
                    {
                        name: "Life as an owner",
                        url: "/caravans-for-sale/life-as-an-owner",
                    },
                    {
                        name: "Buyer's guide",
                        url: "/caravans-for-sale/buyers-guide",
                    },
                    {
                        name: "Pitch developments",
                        url: "/caravans-for-sale/parks/pitch-developments",
                    },
                ],
            },
            {
                name: "Costs & Finance",
                submenu: [
                    {
                        name: "Caravan finance",
                        url: "/caravans-for-sale/caravan-finance",
                    },
                    {
                        name: "Let2offset",
                        url: "/caravans-for-sale/buyers-guide/let2offset",
                    },
                    {
                        name: "Letting your caravan",
                        url: "/caravans-for-sale/buyers-guide/lettings",
                    },
                    {
                        name: "Site fees & running costs",
                        url: "/caravans-for-sale/buyers-guide/site-fees",
                    },
                ],
            },
            {
                name: "Advice & Inspiration",
                submenu: [
                    {
                        name: "10 reasons to buy a static caravan",
                        url: "/caravans-for-sale/advice-inspiration/10-reasons-to-buy-a-static-caravan-with-haven",
                    },
                    {
                        name: "Are static caravans a good investment",
                        url: "/caravans-for-sale/advice-inspiration/are-static-caravans-a-good-investment",
                    },
                    {
                        name: "First time caravan buyer’s guide",
                        url: "/caravans-for-sale/advice-inspiration/first-time-caravan-buyers-guide",
                    },
                    {
                        name: "Dog friendly caravans for sale",
                        url: "/caravans-for-sale/dog-friendly",
                    },
                    {
                        name: "View all",
                        url: "/caravans-for-sale/advice-inspiration",
                    },
                ],
            },
            {
                name: "Get in touch",
                submenu: [
                    {
                        name: "Chat to us",
                        url: "/caravans-for-sale/chat",
                        icon: getIconBaseUrl("chat-blue.svg"),
                    },
                    {
                        name: "Download a brochure",
                        url: "/caravans-for-sale/request-a-brochure",
                        icon: getIconBaseUrl("brochure-blue.svg"),
                    },
                    {
                        name: "Book a park visit",
                        url: "/caravans-for-sale/arrange-a-visit",
                        icon: getIconBaseUrl("arrange-visit-blue.svg"),
                    },
                ],
            },
        ],
    },
    {
        name: "Offers",
        url: "/offers",
        submenu: [
            {
                name: "Best value",
                url: "/offers/best-value",
            },
            {
                name: "Late deals",
                url: "/offers/last-minute-deals",
            },
            {
                name: "Food & Drink offers",
                url: "/offers/food-and-drink",
            },
            {
                name: "Retail offers",
                url: "/discover/shopping/offers",
            },
            {
                name: "Caravan Ownership offers",
                url: "/caravans-for-sale/offers",
            },
            {
                name: "Sign up",
                url: "/newsletter",
            },
        ],
    },
    {
        name: "Help",
        url: "https://support.haven.com",
    },
    {
        name: "Careers",
        url: "https://jobs.haven.com",
    },
];
export const userNavigationDefaultData = [
    {
        name: "Manage my account",
        url: "/my-account/account-details",
    },
    {
        name: "Manage my booking",
        url: "/my-account",
    },
    {
        name: "Book activities",
        url: "/experience/activities/activity-list",
    },
    {
        name: "Pre-arrival information",
        url: "/support/arrival-info",
    },
    {
        name: "Payments",
        url: "/payments",
    },
];
